/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ProfileImportProgressResponse {
  total: number;
  processing: number;
  successful: number;
  failed: number;
  percent: number;
}
